import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
var _effectorFileName = "/builds/gmini/front-common/src/components/Navbar/NavbarDropDown.tsx";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.is-array.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { ArrowDown } from '@gmini/ui-kit';
import { ClickAwayListener } from '@mui/material';
import { ModulesNavButton, ModulesNavPopover, ModulesNavPopoverItem, ModulesNavPopoverDivider, NavbarWrapper } from "./NavbarDropDown.styled";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var NavbarDropDown = function NavbarDropDown(_ref) {
  var onToggle = _ref.onToggle,
      opened = _ref.opened,
      navModules = _ref.navModules,
      onClose = _ref.onClose,
      seoEventHandler = _ref.seoEventHandler;

  var _navModules = _slicedToArray(navModules, 3),
      ourModules = _navModules[0],
      anotherModules = _navModules[1],
      gStationModules = _navModules[2];

  return /*#__PURE__*/_jsxs(NavbarWrapper, {
    children: [/*#__PURE__*/_jsx(ModulesNavButton, {
      hover: opened,
      onClick: function onClick(event) {
        event.preventDefault();
        event.stopPropagation();
        onToggle();
      },
      children: /*#__PURE__*/_jsx(ArrowDown, {
        width: "14px",
        height: "14px",
        color: "#353B60"
      })
    }), opened && /*#__PURE__*/_jsx(ClickAwayListener, {
      onClickAway: onClose,
      children: /*#__PURE__*/_jsxs(ModulesNavPopover, {
        onClick: function onClick(e) {
          return e.stopPropagation();
        },
        children: [gStationModules.map(function (module) {
          return /*#__PURE__*/_jsx("a", {
            target: "_blank",
            href: module.url,
            rel: "noreferrer",
            onClick: function onClick() {
              return seoEventHandler === null || seoEventHandler === void 0 ? void 0 : seoEventHandler(module.name);
            },
            children: /*#__PURE__*/_jsx(ModulesNavPopoverItem, {
              children: module.name
            })
          }, module.id);
        }), gStationModules.length ? /*#__PURE__*/_jsx(ModulesNavPopoverDivider, {}) : null, ourModules.map(function (module) {
          return /*#__PURE__*/_jsx("a", {
            href: module.url,
            onClick: function onClick() {
              return seoEventHandler === null || seoEventHandler === void 0 ? void 0 : seoEventHandler(module.name);
            },
            children: /*#__PURE__*/_jsx(ModulesNavPopoverItem, {
              children: module.name
            })
          }, module.id);
        }), anotherModules.length ? /*#__PURE__*/_jsx(ModulesNavPopoverDivider, {}) : null, anotherModules.map(function (module) {
          return /*#__PURE__*/_jsx("a", {
            target: "_blank",
            href: module.url,
            rel: "noreferrer",
            onClick: function onClick() {
              return seoEventHandler === null || seoEventHandler === void 0 ? void 0 : seoEventHandler(module.name);
            },
            children: /*#__PURE__*/_jsx(ModulesNavPopoverItem, {
              children: module.name
            })
          }, module.id);
        })]
      })
    })]
  });
};